import { Checkbox, DialogContent, DialogTitle, FormControlLabel, GridProps, useTheme } from "@mui/material";
import { ChangeEvent, FC, useState } from "react";
import { Property } from "../api/dtos";
import useProperties from "../hooks/data/useProperties";
import { FormSection, IFormDialogProps, StyledDialog, StyledFormColumn } from "./inputs/CommonFormElements";
import { StyledButton } from "../components/StyledButton";

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
}

interface IPropertyFormProps extends IFormDialogProps {
    updateProperties: (selectedProperties: Property[]) => void;
    initSelection: Property[];
}

const PropertySelectForm: FC<IPropertyFormProps> = ({
        open,
        onClose,
        updateProperties,
        initSelection = []
}) => {
    const theme = useTheme();

    const {data: properties} = useProperties();
    const [formSelectedProperties, setFormSelectedProperties] = useState<Property[]>(initSelection);

    const handleClose = () => {
        updateProperties(formSelectedProperties);
        onClose();
    }

    const handleCheckboxToggle = (
        _event: ChangeEvent<HTMLInputElement>,
        checked: boolean,
        property: Property
    ) => {
        if(!checked) {
            setFormSelectedProperties(formSelectedProperties => formSelectedProperties.filter(x => x.id !== property.id));
        }
        else {
            setFormSelectedProperties([...formSelectedProperties, property]);
        }
    }

    return (
        <StyledDialog 
            onClose={handleClose} 
            open={open}
            maxWidth={'xs'}
        >
            <DialogTitle
                sx={{
                    backgroundColor: theme.palette.secondary.light,
                    color: theme.palette.common.white
                }}
            >
                Select Properties
            </DialogTitle>
            <DialogContent>
                <FormSection>
                    <StyledFormColumn
                        size={COLUMN_SIZING}
                    >
                        {properties?.map(value => 
                            <FormControlLabel
                                sx={{
                                    paddingLeft: "30px",
                                    alignSelf: "flex-start"
                                }}
                                control={
                                    <Checkbox
                                        checked={formSelectedProperties.includes(value)}
                                        onChange={(event, checked) => handleCheckboxToggle(event, checked, value)}
                                    />
                                }
                                label={value.name}
                            />
                        )}
                    </StyledFormColumn>
                </FormSection>
                <FormSection
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end"
                    }}
                >
                    <StyledButton 
                        onClick={handleClose}
                        sx={{
                            width: 100,
                        }}
                    >
                        Close
                    </StyledButton>
                </FormSection>
            </DialogContent>
            
        </StyledDialog>
    );
}

export default PropertySelectForm;